(() => {
  if (window.twoSeasonsGiftWrap) return;
  window.twoSeasonsGiftWrap = true;
  const variant = 68192839106781;

  const attribute = '2Seasons gift wrapping';
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  let busy = false;
  let chain = Promise.resolve();
  let desired = null;
  const setChoice = value => { desired = value; };
  const json = async (path, body) => {
    const response = await nativeFetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Cart update failed');
    return result;
  };
  const showError = () => {
    const error = document.querySelector('[data-gift-error]');
    if (error) error.hidden = false;
  };
  const normalise = async () => {
    const cart = await json('cart.js');
    const wraps = cart.items.filter(item => item.variant_id === variant);
    const eligibilityResponse = await nativeFetch(root + '?section_id=2seasons-gift-eligibility',{cache:'no-store'});
    if (!eligibilityResponse.ok) throw new Error('Eligibility check failed');
    const eligibilityDocument = new DOMParser().parseFromString(await eligibilityResponse.text(),'text/html');
    const eligibilityNode = eligibilityDocument.querySelector('[data-gift-eligibility]');
    if (!eligibilityNode) throw new Error('Eligibility unavailable');
    const hasProducts = JSON.parse(eligibilityNode.textContent).eligible === true;
    const selected = desired ?? (wraps.length > 0 || cart.attributes[attribute] === 'yes');
    const wanted = selected && hasProducts;
    const updates = {};
    wraps.forEach((item,index) => { const quantity = wanted && index === 0 ? 1 : 0; if (item.quantity !== quantity) updates[item.key] = quantity; });
    const savedChoice = selected ? 'yes' : '';
    if (Object.keys(updates).length || (cart.attributes[attribute] || '') !== savedChoice) await json('cart/update.js',{updates,attributes:{[attribute]:savedChoice}});
    if (wanted && !wraps.length) await json('cart/add.js',{items:[{id:variant,quantity:1}]});
    const result = await json('cart.js');
    const checkbox = document.querySelector('[data-gift-wrap-checkbox]');
    if (checkbox) checkbox.checked = selected;
    document.documentElement.classList.toggle('two-seasons-gift-selected',selected);
    return result;
  };
  const queue = () => {
    chain = chain.catch(() => {}).then(normalise);
    return chain;
  };
  window.fetch = async function(input, options) {
    const url = new URL(input instanceof Request ? input.url : String(input), location.origin);
    const mutation = url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
    const response = await nativeFetch(input,options);
    if (!mutation || !response.ok || busy) return response;
    busy = true;
    try {
      const payload = await response.clone().json();
      if (url.pathname.includes('/clear')) setChoice(false);
      if (/\/cart\/(change|update)/.test(url.pathname) && payload.items && !payload.items.some(item=>item.variant_id===variant)) setChoice(false);
      const cart = await queue();
      if (payload.sections) {
        const sectionIds = Object.keys(payload.sections);
        const rendered = await nativeFetch(root + '?sections=' + encodeURIComponent(sectionIds.join(','))).then(r=>r.json());
        payload.sections = rendered;
      }
      if (/\/(change|update|clear)/.test(url.pathname)) Object.assign(payload,cart);
      return new Response(JSON.stringify(payload),{status:response.status,statusText:response.statusText,headers:response.headers});
    } catch (error) {
      showError();
      return response;
    } finally { busy = false; }
  };
  const xhrUrls = new WeakMap();
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method,url,...rest) {
    xhrUrls.set(this,new URL(String(url),location.origin));
    return originalOpen.call(this,method,url,...rest);
  };
  XMLHttpRequest.prototype.send = function(...args) {
    const url = xhrUrls.get(this);
    if (url && url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) {
      this.addEventListener('load',async () => {
        if (this.status < 200 || this.status >= 300) return;
        try {
          if (url.pathname.includes('/clear')) setChoice(false);
          if (/\/cart\/(change|update)/.test(url.pathname)) {
            const payload = this.responseType === 'json' ? this.response : JSON.parse(this.responseText);
            if (payload.items && !payload.items.some(item=>item.variant_id===variant)) setChoice(false);
          }
          await queue();
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        } catch { showError(); }
      },{once:true});
    }
    return originalSend.apply(this,args);
  };
  const init = async () => {
    const check = document.querySelector('[data-gift-wrap-checkbox]');
    if (check) {
      check.disabled = true;
      const cart = await json('cart.js').catch(()=>null);
      const exists = cart?.items.some(item=>item.variant_id===variant);
      check.checked = Boolean(exists || cart?.attributes[attribute] === 'yes');
      const syncCheckout = () => {
        document.documentElement.classList.toggle('two-seasons-gift-selected',check.checked);
        document.querySelectorAll('.shopify-payment-button').forEach(button => { button.hidden = check.checked; });
      };
      syncCheckout();
      check.addEventListener('change',async () => {
        const previous = !check.checked;
        setChoice(check.checked);
        syncCheckout();
        check.disabled = true;
        document.querySelector('[data-gift-error]').hidden = true;
        try { await queue(); document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); }
        catch { setChoice(previous);check.checked=previous;syncCheckout();showError(); }
        finally { check.disabled=false; }
      });
      check.disabled = false;
    }
    if (location.pathname.includes('/cart')) {
      try {
        const before = await json('cart.js');
        const after = await queue();
        const lines = cart => JSON.stringify(cart.items.map(item => [item.key,item.quantity]));
        if (lines(before) !== lines(after)) location.reload();
      } catch { showError(); }
    }
  };
  document.addEventListener('variant:add',async () => { try {await queue();document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));} catch {showError();} });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();

